import { useContext } from "react";
import { Context } from "../context/Context";

const LazyLoad = () => {
  const { authUser, isLoading } = useContext(Context);

  return (
    <>
      {isLoading ? (
        <>
          {/* <div
            style={{
              position: "fixed",
              width: "100%",
              height: "100%",
              zIndex: "1000",
            }}
          ></div>
          <div
            className="sk-circle-fade sk-success"
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
              zIndex: "100000000",
            }}
          >
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
            <div className="sk-circle-fade-dot"></div>
          </div> */}

          <div
            style={{
              position: "absolute",
              // top: "calc(50% - 16.5px)",
              top: "50%",
              right: "calc(50% - 20px)",
              zIndex: "100000000",
            }}
            className="spinner-border spinner-border-lg text-success-app"
            role="status"
          >
            <span className="visually-hidden">در حال بارگذاری ...</span>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default LazyLoad;
